export const FONT_TYPES = {
    DEFAULT: 'DEFAULT',
    HEADING: 'HEADING',
    SUB_HEADING: 'SUB_HEADING',
    PARAGRAPH: 'PARAGRAPH'
};

export const OVERRIDDEN_USER_AGENT = 'Mozilla/5.0 (Linux; Android 11; Pixel 5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4430.91 Mobile Safari/537.36';